module.exports = __webpack_public_path__ + "static/media/English - Teaching - Prayer of penitence and prayer of hope - translated by JL.94a6b5dd.txt";